import { useCallback, useState } from 'react';

export function useBlur() {
  const [wasBlurred, setWasBlurred] = useState(false);

  return {
    wasBlurred,
    onBlur: useCallback(() => {
      setWasBlurred(true);
    }, []),
  };
}
